export default "__VITE_ASSET__BSMVHAi9__"